var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-section"},[_c('v-container',[_c('h1',{staticClass:"text-capitalize grey--text text--darken-2"},[_vm._v(" "+_vm._s(_vm.currentRouteName)+" ")]),_c('transition',[_c('router-view',{staticClass:"mt-6"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }